import React from "react";

import "./EmailThreadMessageDrawer.less";

import { DrawerProps } from "antd/lib/drawer";
import { FormComponentProps } from "@ant-design/compatible/lib/form";
import { Form } from "@ant-design/compatible";
import {
	SendEmailThreadMessageFormValues,
	EmailThreadMessage,
	SendDocumentEmailThreadMessageRequest,
	EmailThreadRecipients,
	SendEmailThreadMessageRequest
} from "@/Contracts/Others/EmailThread";
import { EmailTemplateFileDetails } from "@/Contracts/EmailTemplates";
import { useFeatureFlag } from "@/Hooks/useFeature";
import EmailThreadMessageDrawerFuncComp from "./EmailThreadMessageDrawerFuncComp";
import EmailThreadMessageDrawerClassComp from "./EmaiThreadlMessageDrawerClassComp";

interface SendDocumentGuideDetail {
	SendDocumentEmailGuideUI: React.ElementType | null;
	handleSendDocumentEmailNext?: () => void;
	targetId: string;
	isSendDocumentEmailGuideActive: boolean;
	handleGuideVisiblity?: (value: boolean) => void;
}

interface Props
	extends DrawerProps,
		FormComponentProps<SendEmailThreadMessageFormValues> {
	readonly isNewThread: boolean;
	readonly isDocumentMessage: boolean;
	readonly defaultRecipients: string[] | null;
	readonly emailThreadMessage: EmailThreadMessage | null;
	readonly ignoreAppendEmailSignature?: boolean;
	readonly defaultSubject?: string | null;
	readonly bodyPlaceholder?: string;
	readonly templateBody?: string | null;
	readonly templateAttachments?: EmailTemplateFileDetails[] | null;
	readonly documentId?: string | null;
	readonly opportunityId?: string | null;
	readonly clientId?: string | null;
	readonly useTemplate: boolean;
	readonly isFromDocumentsPage?: boolean;
	readonly allEmailRecipients?: EmailThreadRecipients[];
	readonly isFromEmailTemplatesPage?: boolean;
	readonly onSubmit?: (
		sendEmailThreadMessageRequest?: SendEmailThreadMessageRequest
	) => void;
	readonly onBeforeSubmit?: (
		request: SendDocumentEmailThreadMessageRequest
	) => Promise<void>;
	readonly onClose?: () => void;
	readonly refreshSalesActivities?: (
		shouldRefreshSalesActivities: boolean
	) => void;
	readonly sendDocumentFromConnectedEmailFlag?: boolean;
	readonly hideReceiverMergeTag?: boolean;
	readonly sendDocumentGuideDetail?: SendDocumentGuideDetail;
	readonly purchaseOrderId?: string | null;
}

const EmailThreadMessageDrawer: React.FC<Props> = props => {
	// changes should be made to both the class and functional based component
	const isEmailThreadDrawerFnBased = useFeatureFlag(
		"email_thread_message_drawer_grow"
	);
	return isEmailThreadDrawerFnBased ? (
		<EmailThreadMessageDrawerFuncComp {...props} />
	) : (
		<EmailThreadMessageDrawerClassComp {...props} />
	);
};

const ConnectedForm = Form.create<Props>({
	name: "email_thread_messages_form"
})(EmailThreadMessageDrawer);

export default ConnectedForm;
